import debouncedSaveTemplate from "fantastic/lib/debouncedSaveTemplate";

export default (id, index, width, nextWidth) => (dispatch, getState) => {
  dispatch({
    type: "SECTIONS/UPDATE_TABLE_COLUMNS",
    payload: { id, index, width, nextWidth }
  });
  debouncedSaveTemplate(dispatch, getState);
};
